const services = [
  {
    name: "Web Development",
    description:
      "Modern user-centered websites and interface with MongoDB, ExpressJs, ReactJs, NodeJs.",
    iconUrl: "img/web-design.png",
  },
  {
    name: "App Development",
    description: "Cross Platform mobile app development with React Native.",
    iconUrl: "img/mobile-app-development.png",
  },
  {
    name: "UI/UX Design",
    description:
      "Design accessible Interfaces that align with modern design patterns.",
    iconUrl: "img/ui-ux-design.png",
  },
];

const projects = [
  {
    name: "ZenithGPT",
    description:
      "An AI chatbot built using React Native, leveraging both GPT-3.5-turbo and Davinci models from OpenAI for intelligent and responsive conversations.",
    imgUrl: "",
    sourceCodeUrl: "https://github.com/philipthedeveloper/FreeGPT",
    liveDemoUrl:
      "https://play.google.com/store/apps/details?id=com.freegpt&hl=en",
    stackUsed: ["React Native", "NodeJS"],
  },
  {
    name: "Adutem Innovations",
    description:
      "Developed a digital marketing agency website, during which I functioned as the fullstack development engineer.",
    imageUrl: "",
    sourceCodeUrl: "https://github.com/Adutem/Adutem-Innovation/tree/develop",
    liveDemoUrl: "https://adutem-innovation.onrender.com/",
    stackUsed: ["React", "NodeJS", "MongoDB"],
  },
  {
    name: "Acorn Auto",
    description:
      "Developed the Acorn Tire & Auto website, during which I functioned as the fullstack development engineer.",
    imageUrl: "",
    sourceCodeUrl: "https://github.com/philipthedeveloper/acorn-auto",
    liveDemoUrl: "https://www.acornauto.com/",
    stackUsed: ["React", "NodeJS", "MongoDB"],
  },
  {
    name: "Tunik Engineering",
    description:
      "Developed the Tunik Engineering Official Website, during which I functioned as the fullstack development engineer.",
    imageUrl: "",
    sourceCodeUrl: "https://github.com/philipthedeveloper/tunik-engineering",
    liveDemoUrl: "https://tunik-engineering.netlify.app/",
    stackUsed: ["JavaScript", "CSS3"],
  },
  {
    name: "Streaks",
    description:
      "An admin system for creating mutliple choice questionaire. Requires auth access, so please reach out if you need to test.",
    imageUrl: "",
    sourceCodeUrl: "https://github.com/philipthedeveloper/streaks-admin",
    liveDemoUrl: "https://admin-streaks-portal.netlify.app/",
    stackUsed: ["React", "NodeJS", "MongoDB"],
  },
  {
    name: "Songify",
    description:
      "A desktop music player offering all the essential functionalities of a modern music player with an intuitive user interface.",
    imageUrl: "img/music_player.jpg",
    sourceCodeUrl: "https://github.com/philipthedeveloper/desktop-music-player",
    liveDemoUrl: "https://philipthedeveloper.github.io/desktop-music-player/",
    stackUsed: ["JavaScript", "Firebase"],
  },
  {
    name: "Smart Bio-Digester",
    description:
      "Developed an API gateway enabling communication between a tracking web application and IoT devices, supporting both RESTful and real-time interactions.",
    imageUrl: "img/music_player.jpg",
    sourceCodeUrl: "https://github.com/philipthedeveloper/ecopulse-lambda",
    liveDemoUrl: "#",
    stackUsed: ["AWS S3", "AWS Lambda", "NodeJS"],
  },
  // {
  //   name: "Codeverse",
  //   description:
  //     "An admin portal designed for creating courses and adding e-book materials, developed for the Codeverse mobile application.",
  //   imageUrl: "img/codeverse.png",
  //   sourceCodeUrl: "https://github.com/philipthedeveloper/codeverse_admin",
  //   liveDemoUrl: "https://codeverse-admin.netlify.app/",
  //   stackUsed: ["React", "Firebase", "NodeJS"],
  // },
  {
    name: "Bonsai Price Page",
    description:
      "A beautifully crafted pricing page designed for a company called Bonsai, demonstrating clean and intuitive UI practices.",
    imageUrl: "img/bonsai.png",
    sourceCodeUrl: "https://github.com/philipthedeveloper/3-Bonsai",
    liveDemoUrl: "https://philipthedeveloper-bonsai.netlify.app/",
    stackUsed: ["React", "JavaScript"],
  },
];

const certifications = [
  {
    title: "HTML Essential Training",
    imgUrl: "/img/html_essential_training.jpg",
  },
  {
    title: "CSS Essential Training",
    imgUrl: "/img/css_essential_training.jpg",
  },
  {
    title: "Javascript Essential Training",
    imgUrl: "/img/javascript_essential_training.jpg",
  },
];

export { services, projects, certifications };
